<template>
  <div>
    <v-layout class="pb-16">
      <v-flex class="pr-30" xs12>
        <select-field
          v-model="form.eventCategoryId"
          :validator="vs.eventCategoryId"
          :items="workflowUi(categories)"
          item-select="id"
          item-render="name"
          :label="adminText('workflowsAll.category_2f46df4', 'Category*')"
          @change="onSelectedCategory"
        />
      </v-flex>
      <v-flex xs12>
        <select-field
          v-model="form.interests"
          :items="workflowUi(getSubCategories)"
          item-select="id"
          item-render="name"
          :disabled="!form.eventCategoryId || !getSubCategories.length"
          :validator="vs.interests"
          :label="adminText('workflowsAll.subcategory_e1d9ef4', 'Subcategory*')"
          multiple
        />
      </v-flex>
    </v-layout>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.title"
        :label="adminText('workflowsAll.event_title_f33a025', 'Event title*')"
        :error-messages="{ maxLength: adminText('workflowsAll.title_is_limited_to_120_characters_426459b', 'Title is limited to 120 characters.') }"
        autofocus
        :validator="vs.title"
      />
    </v-flex>
    <v-layout class="pb-16">
      <v-flex class="pr-30" xs12>
        <datetime-field
          v-model="form.from"
          :validator="vs.from"
          :label="adminText('workflowsAll.starts_4edb2ec', 'Starts*')"
          :max="form.to ? form.to.toString() : null"
          :error-messages="{
            minDate: adminText('workflowsAll.start_date_must_be_a_future_date_fd9430e', 'Start date must be a future date'),
            maxDate: adminText('workflowsAll.start_date_should_be_before_the_end_of_the_ev_ec2ed4d', 'Start date should be before the end of the event'),
          }"
        />
      </v-flex>
      <v-flex xs12>
        <datetime-field
          v-model="form.to"
          :validator="vs.to"
          :label="adminText('workflowsAll.ends_65bb821', 'Ends*')"
          :min="
            form.from
              ? form.from.toString()
              : new Date(new Date().getTime() + 1000 * 60 * 5).toString()
          "
          :error-messages="{
            minDate: adminText('workflowsAll.end_date_should_not_be_before_the_start_of_th_019643c', 'End date should not be before the start of the event'),
          }"
        />
      </v-flex>
    </v-layout>
    <v-flex>
      <location-field v-model="form.location" :validator="vs.location" />
    </v-flex>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'general-info-form',
  components: {},
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  computed: {
    getSubCategories() {
      const selectedCategory = this.categories.find(c => c.id === this.form.eventCategoryId)

      if (!selectedCategory) {
        return []
      }

      return selectedCategory.subCategories || []
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  methods: {
    onSelectedCategory() {
      this.form.interests = []
    },
  },
}
</script>

<style scoped>
@media (max-width: 800px) {
  .pb-16 {
    flex-direction: column;
  }

  .pr-30 {
    margin-right: 0 !important;
  }
}

@media (max-width: 800px) {
  .pb-8 {
    flex-direction: column;
    margin-bottom: 1rem;
  }

  .pr-30,
  .pr-30 + * {
    margin-right: 0 !important;
  }

  .pr-30 {
    margin-bottom: 1rem;
  }
}
</style>
